/**
 * @deprecated prefer GridRowModel.
 */

/**
 * The key value object representing the data of a row.
 */

/**
 * The grid rows total height and row positions.
 */

/**
 * The type of Id supported by the grid.
 */

/**
 * The function to retrieve the id of a [[GridRowModel]].
 */

/**
 * An helper function to check if the id provided is valid.
 * @param {GridRowId} id Id as [[GridRowId]].
 * @param {GridRowModel | Partial<GridRowModel>} row Row as [[GridRowModel]].
 * @param {string} detailErrorMessage A custom error message to display for invalid IDs
 */
export function checkGridRowIdIsValid(id, row) {
  let detailErrorMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'A row was provided without id in the rows prop:';
  if (id == null) {
    throw new Error(['MUI: The data grid component requires all rows to have a unique `id` property.', 'Alternatively, you can use the `getRowId` prop to specify a custom id for each row.', detailErrorMessage, JSON.stringify(row)].join('\n'));
  }
}